export const SAGA_GUARDS = {
  FPOOL_GENERAL: 'SAGA_RESOLVE_FPOOL_GENERAL',
  FPOOL_SPECIAL: 'SAGA_RESOLVE_FPOOL_SPECIAL',
  FPOOL_FASTQUOTE: 'SAGA_RESOLVE_FPOOL_FASTQUOTE',
  PRODUCTS: 'SAGA_RESOLVE_FPOOL_PRODUCTS',
  VEHICLE_BRANDS: 'SAGA_RESOLVE_VEHICLE_BRANDS',
  VEHICLE_MODELS: 'SAGA_RESOLVE_VEHICLE_MODELS',
  VEHICLE_VERSIONS: 'SAGA_RESOLVE_VEHICLE_VERSIONS',
  QUOTE: 'SAGA_REQUIRE_QUOTE',
  AGENCIES: 'SAGA_RESOLVE_AGENCIES',
  RESOLVE_QUOTEDOC: 'SAGA_RESOLVE_QUOTEDOC',
  RESOLVE_OTHERDOCS: 'SAGA_RESOLVE_OTHERDOCS',
  RESOLVE_OTHERDOC: 'SAGA_RESOLVE_OTHERDOC',
  SEND_QUOTEDOC: 'SAGA_SEND_QUOTEDOC',
  SEND_SUPPORT_AGENCY: 'SAGA_SEND_SUPPORT_AGENCY',
}
